// extracted by mini-css-extract-plugin
export default {"container":"PageContainer_container__Y3rbb"};